module.exports = "/static/images/LJN-logo-2022.png";